import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux'
import { store } from './store'
import { PersistGate } from 'redux-persist/es/integration/react'
import { persistStore } from 'redux-persist'
 
let persistor = persistStore(store);

const container = document.getElementById('root') ?? {} as HTMLElement;

const root = ReactDOM.createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App/>
        </PersistGate>
    </Provider>
);
